export default __webpack_public_path__ + "static/media/bg.1f356643.jpg";